export default __webpack_public_path__ + "static/media/temp stay E8 - Seasonal Work (more than 90 days).a50e922f.jpg";